module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-41cf4a2c5dd9d39f3ae501bdb0c88465.jpg";